module.exports = __webpack_public_path__ + "img/mada.da73db69.png";